<template>
  <button aria-label="Settings" title="Settings" @click="$emit('click')">
    <img src="../../assets/cog.svg" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: {
    click: () => true,
  },
})
</script>
